import store from '../store'
import * as apis from '../api'
import Vue from 'vue'
import { linkTranslation } from '@/utils/index.js'
import { GetRequest } from './index'

const map = {
  himo: ['/pagesPreload/loginByPhone/index?back=true&notPass=1', '/pages/index/index', 'https://wxaurl.cn/5qGXlELRzon'],
  himo_ali: ['/pagesPreload/loginByPhone/index?back=true&notPass=1', '/pages/index/index', 'https://wxaurl.cn/5qGXlELRzon'],
  family: ['/pagesPreload/login/index', '/pages/home/index', 'https://wxaurl.cn/5qGXlELRzon']
}

function get_params () {
  const params = GetRequest(window.location.href)
  store.dispatch('state_update', { params })
  // 设置缓存与视觉品牌样式
  if (params.x_stream_id) localStorage.setItem('x_stream_id', params.x_stream_id)
  if (params.app_name) document.body.setAttribute('app', params.app_name)

  return params
}

function get_user () {
  apis.getUserInfo().then(res => {
    if (res.success) {
      const { userId, phone, name, wxName } = res.msg
      store.dispatch('state_update', {
        user: {
          id: userId,
          phone,
          name: wxName || name
        }
      })
      store.dispatch('state_update', { logined: 'logined' })
    }
  }).catch(() => {
    localStorage.removeItem('x_stream_id')
    store.dispatch('state_update', { logined: 'unlogin' })
  })
}

function firmSdk (calls, str) {
  if (window[str]) {
    calls()
  } else {
    setTimeout(() => {
      firmSdk(calls, str)
    }, 500)
  }
}

function loadSDK () {
  const ua = navigator.userAgent.toLowerCase()
  const ptn1 = /MicroMessenger/ig
  const ptn2 = /AlipayClient/ig
  if (ptn1.test(ua)) {
    document.writeln('<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"' + '>' + '<' + '/' + 'script>')
    firmSdk(() => {
      window.wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          store.dispatch('state_update', { env: 'wx' })
        } else {
          store.dispatch('state_update', { env: 'h5' })
        }
      })
    }, 'wx')
  } else if (ptn2.test(ua)) {
    document.writeln('<script src="https://appx/web-view.min.js"' + '>' + '<' + '/' + 'script>')
    firmSdk(() => {
      window.my.getEnv(res => {
        if (res.miniprogram) {
          store.dispatch('state_update', { env: 'ali' })
        } else {
          store.dispatch('state_update', { env: 'h5' })
        }
      })
    }, 'my')
  } else {
    store.dispatch('state_update', { env: 'h5' })
  }
}

function pre_init (param) {
  const { app_name = 'himo' } = param || get_params()

  // 确定环境
  if (!param) loadSDK()



  // 跳转配置
  Vue.prototype.goLinks = e => {
    const brand = app_name || 'himo'
    const links = map[brand]
    let sdk = false
    if (store.state.env === 'wx') {
      sdk = window.wx.miniProgram
    } else if (store.state.env === 'ali') {
      sdk = window.my
    }

    if (sdk) {
      if (e && e.type === 'login') {
        // 处理webview二级页面 登录回跳的问题
        const url = app_name === 'himo' ? `${links[0]}&returnUrl=${linkTranslation(window.location.href)}` : links[0]
        sdk.navigateTo({ url })
      } else {
        // -- 缦图定制化逻辑 start
        if (e?.isMantuCustomization) return sdk.navigateTo({ url: '/pages/webview/jump?miniType=MAINTO&miniPath=/pages/index/home&type=tickets' })
        // -- 缦图定制化逻辑 end
        sdk.switchTab({ url: links[1] })
      }
    } else if (e && e.link) {
      window.location.href = e.link
    } else {
      const h5Links = {
        himo: [
          'http://fed.dev.hzmantu.com/develop-himo-user/index.html#/',
          'http://fed.pre.hzmantu.com/develop-himo-user/index.html#/',
          'https://m.haimati.cn/#/'
        ],
        kids: [
          'http://fed.dev.hzmantu.com/ops-himo-kids-mobile/index.html',
          'http://fed.pre.hzmantu.com/ops-himo-kids-mobile/index.html',
          'https://m.himokids.com/?v2=#/home'
        ]
      }
      let inx = ['dev', 'pre', 'production'].indexOf(process.env.NODE_ENV)
      if (inx === -1) inx = 0
      window.location.href = h5Links[brand][inx]
    }
  }

  // 确定登录状态
  if (localStorage.getItem('x_stream_id')) {
    get_user()
  } else {
    store.dispatch('state_update', { logined: 'unlogined' })
  }
}

export default pre_init
